import { Component, OnInit, inject } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  AuthCookieService,
  AuthService,
  IdleService,
  SignalRService,
} from '@vinnova/auth';
import { BetalningsuppgiftReminderService } from '@vinnova/e-tjanster';
import { TranslateService } from '@vinnova/translation';
import { AnalyticsInitializerService } from '@vinnova/utilities';
import { environment } from '../environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [],
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly analyticsInit = inject(AnalyticsInitializerService);

  constructor(
    private translateService: TranslateService,
    private authCookieService: AuthCookieService,
    private idleService: IdleService,
    private authService: AuthService,
    private signalRService: SignalRService,
    private betalningsuppgiftReminderService: BetalningsuppgiftReminderService,
  ) {}

  ngOnInit() {
    void this.analyticsInit.load(environment.ga4MeasurementId);

    this.authService
      .onLoggedIn([this.idleService.initIdle()])
      .pipe(untilDestroyed(this))
      .subscribe();

    this.authService
      .onLoggedIn()
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this.signalRService.init(
          [environment.b2cMsalConfig.scope],
          environment.b2cMsalConfig.authority,
        );
        this.betalningsuppgiftReminderService.showBetalningsuppgiftReminderModal();
      });

    this.translateService
      .setActiveLang()
      .pipe(untilDestroyed(this))
      .subscribe();

    this.authCookieService
      .tokenSuccess()
      .pipe(untilDestroyed(this))
      .subscribe();
  }
}
